import context, { Constants } from '@truckdown/systems';
import { INavItem } from '@truckdown/components-systems';
import { defineComponent, Ref, ref, onMounted, computed } from 'vue';

const alwaysDisplay = function () {
    return true;
}

interface IProps {
    //openSection: string,
    activeItem: string,
    subSection: string,
    //subItems: INavItem[]
}

interface IData {
    hideNav: Ref<boolean>,
    items: Ref<IItem[]>,
    shownSubMenus: Ref<string[]>
};

interface IItem {
    id?: string;
    name: string;
    url: string;
    tooltip?: string;
    icon: string;
    iconType?: string;
    active: boolean;
    subItems: ISelectableItem[];
    display: () => boolean;
}

interface ISelectableItem extends INavItem {
    id: string;
    subItems: ISelectableItem[];
    iconType?: string;
    active: boolean;
}

const getSubItem = function (name: string, icon: string, url: string, iconType?: string, display?: () => boolean, tooltip?: string, id?: string): ISelectableItem {
    return {
        id: id ?? name,
        name: name,
        icon: icon,
        iconType: iconType,
        url: url,
        tooltip: tooltip,
        active: false,
        display: display ?? alwaysDisplay,
        subItems: []
    };
}

const getSubItems = function () {
    return [
        getSubItem('Get Started', 'faCirclePlay', '/developer/get-started'),
        getSubItem('Webhook Integration', 'faPuzzlePiece', '/developer/webhooks'),
        getSubItem('Slack Integration', 'faSlack', '/developer/slack', 'brand'), //fabrands
        getSubItem('Microsoft Teams Integration', 'faMicrosoft', '/developer/teams', 'brand'), //fabrands
        getSubItem('Account Types', 'faUsers', '/developer/account-types'),
        getSubItem('API Reference', 'faReadme', '/developer/api-reference', 'brand')
    ]
}

const getItems = function () {
    return [
        {
            name: 'TruckDown API',
            icon: 'faShareNodes',
            url: '/developer',
            active: false,
            subItems: getSubItems(),
            display: alwaysDisplay
        }
    ];
};

const getNavHideStatus = function () {
    var queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has('hsn')) {
        return true;
    }

    return window.innerWidth < 525;
}

const getData = function (props: IProps): IData {
    var items = getItems();
    setMenuOptions(props, items);

    return {
        hideNav: ref<boolean>(getNavHideStatus()),
        items: ref<IItem[]>(items),
        shownSubMenus: ref<string[]>(['TruckDown API'])
    }
}

const getSection = function (name: string, items: IItem[]): IItem | ISelectableItem | null {
    for (let i = 0; i < items.length; i++) {
        var itm = items[i];
        if (itm.id == name || itm.name == name) {
            return itm;
        }

        for (let i2 = 0; i2 < itm.subItems.length; i2++) {
            var subItm = itm.subItems[i2];
            if (subItm) {
                if (subItm.id == name) {
                    return subItm;
                }

                for (let i3 = 0; i3 < subItm.subItems.length; i3++) {
                    var final = subItm.subItems[i3];

                    if (final.id == name) {
                        return final;
                    }
                }
            }
        }
    }
    return null;
}

const setMenuOptions = function (props: IProps, items: IItem[]) {
    if (props.activeItem.length > 0) {
        let activeSection = getSection(props.activeItem, items);
        if (activeSection != null) {
            activeSection.active = true;
        }
    }
}

const getMethods = function (data: IData) {
    return {
        toggleNav: function (ev: Event) {
            data.hideNav.value = !data.hideNav.value;
            var queryParams = new URLSearchParams(window.location.search);
            if (data.hideNav.value) {
                queryParams.set('hsn', '1');
                history.replaceState(null, '', '?' + queryParams.toString());
            } else {
                if (queryParams.has('hsn')) {
                    queryParams.delete('hsn');
                    var newSearch = queryParams.toString();
                    if (newSearch.length == 0) {
                        history.replaceState(null, '', location.pathname);
                    } else {
                        history.replaceState(null, '', '?' + queryParams.toString());
                    }
                }
            }
        },
        toggleMenu: function (name: string) {
            if (data.shownSubMenus.value.some(v => v == name)) {
                data.shownSubMenus.value = data.shownSubMenus.value.filter(v => v != name);
                return true;
            } else {
                data.shownSubMenus.value.push(name);
            }
        },
        shouldShowMenu: function (name: string) {
            if (data.shownSubMenus.value.some(v => v == name)) {
                return true;
            }
            return false;
        },
        getUrl: function (url: string) {
            if (data.hideNav.value) {
                var hasQuery = url.indexOf('?') > 0;
                if (hasQuery) {
                    return url + '&hsn=1';
                } else {
                    return url + '?hsn=1';
                }
            }

            return url;
        }
    };
}

export default defineComponent({
    name: 'DeveloperSideNav',
    props: {
        //openSection: {
        //    type: String,
        //    default: ''
        //},
        activeItem: {
            type: String,
            default: ''
        },
        subSection: {
            type: String,
            default: ''
        } //,
        //subItems: {
        //    type: Array as () => INavItem[],
        //    default: []
        //}
    },
    setup: function (props) {
        let data = getData(props as IProps);
        let methods = getMethods(data);

        return {
            ...data,
            ...methods
        };
    }
});